import { configureStore } from '@reduxjs/toolkit';
import snackbarReducer from './reducer/snackbarSlice';
import authUserReducer from './reducer/authUserSlice';
import drawerReducer from './reducer/drawerSlice';
import dialogReducer from './reducer/dialogSlice';
import permissionReducers from './reducer/permissionSlice';
import sortingReducer from "./reducer/sortingSlice";
import tableSearchReducer from "./reducer/tableSearchSlice"; 
import showFiltersReducer from "./reducer/showFiltersSlice";
import projectLocationReducer from "./reducer/projectLocationSlice";
import refreshReducer from "./reducer/refreshSlice";
import tabReducer from "./reducer/tabSlice";
import commonFilterReducer from "./reducer/CommonFilterSlice";
import hospitalSelectionReducer from "./reducer/HospitalSelectionSlice";
import dashboardFilterReducer from "./reducer/dashboardFilterSlice";
import languageReducer from './reducer/languageSlice';
import { ISLIVE } from '../utils/base-urls';

const store = configureStore({
    reducer: {
        snackbar: snackbarReducer,
        authUser: authUserReducer,
        drawer: drawerReducer,
        dialog: dialogReducer,
        permission: permissionReducers,
        sorting: sortingReducer,
        tableSearch: tableSearchReducer,
        showFilters: showFiltersReducer,
        location: projectLocationReducer,
        refresh: refreshReducer,
        tab: tabReducer,
        filters: commonFilterReducer,
        hospitalSelection :hospitalSelectionReducer,
        dashboardFilter: dashboardFilterReducer,
        language: languageReducer,
    },
    devTools: !ISLIVE,
});

export type AppDispatch = typeof store.dispatch;

export type RootState = ReturnType<typeof import('./store').default.getState>

export default store;